/**
 * @generated SignedSource<<ebc3f39a9a277fa6a0aeb1442ad6bd21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BotStatus = "active" | "paused" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useBrainSearchBotFragment$data = {
  readonly brainSearchBot: {
    readonly enableMedia: boolean;
    readonly enableSources: boolean;
    readonly enableSuggestedContentPrompts: boolean;
    readonly enableSuggestedPrompts: boolean;
    readonly enableWebSearch: boolean;
    readonly id: string;
    readonly name: string;
    readonly status: BotStatus;
    readonly suggestedPrompts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly prompt: string;
        };
      }>;
    } | null;
  } | null;
  readonly " $fragmentType": "useBrainSearchBotFragment";
};
export type useBrainSearchBotFragment$key = {
  readonly " $data"?: useBrainSearchBotFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBrainSearchBotFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBrainSearchBotFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Bot",
      "kind": "LinkedField",
      "name": "brainSearchBot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableWebSearch",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableMedia",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableSources",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableSuggestedPrompts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableSuggestedContentPrompts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BotSuggestedPromptNodeConnection",
          "kind": "LinkedField",
          "name": "suggestedPrompts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BotSuggestedPromptNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BotSuggestedPrompt",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "prompt",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "e24a5615047a673f2b77d9bbc1e58dcd";

export default node;
